// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import CreateContractModal from 'components/common/CreateContractModal';
import SectionHeader from 'components/text/SectionHeader';

const TopArea = ({ clientId }) => (
  <div style={{ marginTop: 30 }}>
    <SectionHeader>CONTRACTS</SectionHeader>
    <CreateContractModal triggerType="anchor" clientId={clientId} />
  </div>
);

export default TopArea;



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientContracts/TopArea/index.js